var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"8","height":"12","viewBox":"0 0 8 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.91016 1.41L3.33016 6L7.91016 10.59L6.50016 12L0.500156 6L6.50016 0L7.91016 1.41Z","fill":"#B7C3CD"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }